// extracted by mini-css-extract-plugin
export default {"grid_wrapper":"BookPage_grid_wrapper__oYQdg","page_setting_btn":"BookPage_page_setting_btn__G4hmq"};